import React from 'react';
import { Country as CSC } from 'country-state-city';
import Flag from 'react-world-flags';

const Country = ({ isoCode }) => {
  return isoCode && isoCode.length === 2 ? (
    <span className="d-flex  align-items-center ">
      <Flag code={isoCode} style={{ width: '25px', marginRight: '4px' }} />
      {CSC.getCountryByCode(isoCode)?.name}
    </span>
  ) : (
    '---'
  );
};

export default Country;
